module.exports = __webpack_public_path__ + "static/scale-model-of-around-town-inc-in-ann-arbor-michigan-c51db45625ba93ee546c1b3385752609.png";